/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B070020 入荷・入庫一括確定
 */
import { Box } from "@mui/material";
import { Column, Query } from "@material-table/core";
import {
  SText,
  SCodeSelect,
  SDateField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
  msgState,
  SNumberCell,
  SDateCell,
  SCodeCheckCell,
  SCodeSelectCell,
} from "components";
import {
  getSCode,
  KafusokuRiyu,
  KanryoKbn,
  SCode,
  ShohinshubetsuKbn,
} from "messages/codes";
import { labels } from "messages/labels";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, menusState, useFocus } from "states";
import { date, dateAt, mapIds } from "services";
import { B000170 } from "pages/b000/B000170";
import { B000160 } from "pages/b000/B000160";
import { B000222 } from "pages/b000/B000222";
import { B000111, B000200 } from "pages";
import {
  kanryoKbn,
  locasentaku,
  meishoKbn,
  nyukasentaku,
  nyukosentaku,
  recordKbn,
  shohinshubetsuKbn,
  zaikokanriKbn,
} from "services/codes";
import {
  B000111KakoshubetsuNm,
  B000170ShireNm,
  B000200ShohinNm,
  catchRestError,
} from "clients/rest";
import { useNavigate } from "react-router-dom";
import {
  B070020Find,
  B070020FindRequest,
  B070020NyukayoteiRequest,
  B070020Update,
  B070020UpdateRequest,
} from "clients/rest/b070/B070020";

// TODO: 2行目以降フォーカスされない
// TODO: 再検索後、フォーカスされない

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  shireCd: string;
  shireNm: string;
  juchudenpyoNo: string;
  hachudenpyoNo: string;
  shohinCd: string;
  shohinNm: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  juchuhinhasoYmdFrom: string;
  juchuhinhasoYmdTo: string;
  zoneCdFrom: string;
  zoneCdTo: string;
  kakoshubetsuCd: string;
  kakoshubetsuNm: string;
  shohinshubetsuKbn: SCode;
  kanryoKbn: SCode;
  locationCd: string;
  nyukaYmd: string;
  nyukoYmd: string;
}>;

// テーブルデータ定義
type Data = Partial<{
  gyoNo: number;
  locasentaku: string;
  recordKbn: number;
  nyukayoteikanriNo: number;
  shiredenpyoNo: number;
  shiregyoNo: number;
  juchudenpyoNo: number;
  juchugyoNo: number;
  juchudenpyoNoF: string;
  hachudenpyoNo: number;
  hachugyoNo: number;
  hachudenpyoNoF: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  shohinshubetsuKbn: number;
  locationCd: string;
  locationCdF: string;
  zaikokanriKbn: string;
  nyukayoteiYmd: string;
  nyukayoteisu: number;
  minyukasu: number;
  kakuteisu: number;
  nyukasentaku: string;
  nyukosentaku: string;
  nyukaYmdBefore: string;
  nyukaYmd: string;
  nyukoYmdBefore: string;
  nyukoYmd: string;
  seizoNo: string;
  kanryoKbnBefore: number;
  kanryoKbn: number;
  kafusokuRiyu: SCode;
  version: number;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  shireCd: "",
  shireNm: "",
  juchudenpyoNo: "",
  hachudenpyoNo: "",
  shohinCd: "",
  shohinNm: "",
  nyukayoteiYmdFrom: date(),
  nyukayoteiYmdTo: date(),
  juchuhinhasoYmdFrom: "",
  juchuhinhasoYmdTo: "",
  zoneCdFrom: "",
  zoneCdTo: "",
  kakoshubetsuCd: "",
  kakoshubetsuNm: "",
  shohinshubetsuKbn: undefined,
  kanryoKbn: getSCode(KanryoKbn, "1"),
  locationCd: "",
  nyukaYmd: date(),
  nyukoYmd: date(),
};

const focusId = "B070020";

// B070020 入荷・入庫一括確定
export const B070020 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef<any>();
  // 初回検索用のフラグ
  const searched = useRef(false);
  // 検索ボタン押下時に初期ページにするステート
  const isDefaultPage = useRef(false);
  // 編集中の更新フラグ
  const editing = useRef(false);
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();
  // 実行ボタン活性制御
  const [disabledRunButton, setDisabledRunButton] = useState(true);
  // menusステート取得
  const menus = useRecoilValue(menusState);
  // 画面ID
  const gamenId = "070020";
  // 営業所権限取得
  const eigyosyoKengen = menus["070"].pages[gamenId].eigyosyoKengen;
  // 編集行
  const rows = useRef<Data[]>([]);
  // セル値取得
  const cellValue = (gyoNo: number | undefined, name: string) => {
    const value: any = rows.current.filter((v) => v.gyoNo === gyoNo).pop();
    if (value && name in value) return value[name];
    return undefined;
  };
  // 編集行更新
  const updateRows = () => {
    editing.current = true;
    searched.current = true;
    tableRef.current.onQueryChange();
  };
  // カラム編集
  const editCell = (gyoNo: number | undefined, name: string, value: any) => {
    rows.current = rows.current.map((v: Data) => {
      if (v.gyoNo === gyoNo) (v as any)[name] = value;
      return v;
    });
  };
  // ページサイズ
  const pageSize = 100;
  // テーブルを定義する。
  const columns: Column<Data>[] = [
    {
      field: "locasentaku",
      title: "ロケ選択",
      width: "4rem",
      cellStyle: { height: "25px" },
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SCodeCheckCell
            editProps={props}
            value={cellValue(gyoNo, "locasentaku")}
            on={locasentaku.on}
            off={locasentaku.off}
            onChange={(_, checked) => {
              const value = checked ? locasentaku.on : locasentaku.off;
              editCell(gyoNo, "locasentaku", value);
            }}
            disabled={
              props.rowData.zaikokanriKbn === zaikokanriKbn.off ||
              props.rowData.kanryoKbnBefore === kanryoKbn.completed
            }
          />
        );
      },
    },
    {
      field: "juchudenpyoNoF",
      title: "受注No.",
      width: "8rem",
      editable: "never",
    },
    {
      field: "hachudenpyoNoF",
      title: "発注No.",
      width: "8rem",
      editable: "never",
    },
    {
      field: "shohinCd",
      title: "商品コード",
      width: "7rem",
      editable: "never",
    },
    { field: "janCd", title: "JANコード", width: "9rem", editable: "never" },
    { field: "shohinNm", title: "商品名", width: "14rem", editable: "never" },
    {
      field: "locationCdF",
      title: "ロケーション",
      width: "10rem",
      editable: "never",
      render: (data) => data.locationCdF,
    },
    {
      field: "nyukayoteiYmd",
      title: "入荷予定日",
      width: "9rem",
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SDateCell
            editProps={props}
            value={cellValue(gyoNo, "nyukayoteiYmd")}
            onBlur={(event) => {
              const value = dateAt(event.currentTarget.value);
              editCell(gyoNo, "nyukayoteiYmd", value);
            }}
            onAccept={(date) => {
              editCell(gyoNo, "nyukayoteiYmd", date);
            }}
            disabled={
              props.rowData.recordKbn === recordKbn.shiremei ||
              props.rowData.kanryoKbnBefore === kanryoKbn.completed
            }
          />
        );
      },
    },
    {
      field: "nyukayoteisu",
      title: "入荷予定数　",
      width: "6rem",
      align: "right",
      render: (data) => data.nyukayoteisu?.toLocaleString(),
      editable: "never",
    },
    {
      field: "minyukasu",
      title: "未入荷数　",
      width: "6rem",
      align: "right",
      render: (data) => data.minyukasu?.toLocaleString(),
      editable: "never",
    },
    {
      field: "kakuteisu",
      title: "確定数　",
      width: "6rem",
      align: "right",
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SNumberCell
            editProps={props}
            value={cellValue(gyoNo, "kakuteisu")}
            size={6}
            align="right"
            onBlur={(event) => {
              const value = event.currentTarget.value;
              editCell(gyoNo, "kakuteisu", value);
            }}
            disabled={
              props.rowData.recordKbn === recordKbn.shiremei ||
              props.rowData.kanryoKbnBefore === kanryoKbn.completed
            }
          />
        );
      },
    },
    {
      field: "nyukasentaku",
      title: "入荷",
      width: "4rem",
      cellStyle: { height: "25px" },
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SCodeCheckCell
            editProps={props}
            value={cellValue(gyoNo, "nyukasentaku")}
            on={nyukasentaku.on}
            off={nyukasentaku.off}
            onChange={(_, checked) => {
              if (checked) {
                editCell(gyoNo, "nyukasentaku", nyukasentaku.on);
              } else {
                editCell(gyoNo, "nyukasentaku", nyukasentaku.off);
                if (props.rowData.nyukosentaku === nyukosentaku.on) {
                  editCell(gyoNo, "nyukosentaku", nyukosentaku.off);
                }
              }
            }}
            disabled={
              props.rowData.recordKbn === recordKbn.shiremei ||
              props.rowData.kanryoKbnBefore === kanryoKbn.completed
            }
          />
        );
      },
    },
    {
      field: "nyukosentaku",
      title: "入庫",
      width: "4rem",
      cellStyle: { height: "25px" },
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SCodeCheckCell
            editProps={props}
            value={cellValue(gyoNo, "nyukosentaku")}
            on={nyukosentaku.on}
            off={nyukosentaku.off}
            onChange={(_, checked) => {
              if (checked) {
                editCell(gyoNo, "nyukosentaku", nyukosentaku.on);
                if (
                  props.rowData.nyukasentaku === nyukasentaku.off &&
                  props.rowData.recordKbn !== recordKbn.shiremei &&
                  props.rowData.kanryoKbnBefore !== kanryoKbn.completed
                ) {
                  editCell(gyoNo, "nyukasentaku", nyukasentaku.on);
                }
              } else {
                editCell(gyoNo, "nyukosentaku", nyukosentaku.off);
              }
            }}
            disabled={
              props.rowData.zaikokanriKbn === zaikokanriKbn.off ||
              props.rowData.kanryoKbnBefore === kanryoKbn.completed
            }
          />
        );
      },
    },
    { field: "seizoNo", title: "製造番号", width: "4rem", editable: "never" },
    {
      field: "kanryoKbnBefore",
      title: "完了",
      width: "4rem",
      render: (data) => {
        if (!data.kanryoKbnBefore) return "";
        if (data.kanryoKbnBefore === kanryoKbn.completed) return "完了";
        return "";
      },
      editable: "never",
    },
    {
      field: "kanryoKbn",
      title: "完了選択",
      width: "4rem",
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SCodeCheckCell
            editProps={props}
            value={cellValue(gyoNo, "kanryoKbn")}
            on={kanryoKbn.completed}
            off={kanryoKbn.incomplete}
            onChange={(_, checked) => {
              const value = checked
                ? kanryoKbn.completed
                : kanryoKbn.incomplete;
              editCell(gyoNo, "kanryoKbn", value);
            }}
            disabled={
              props.rowData.recordKbn === recordKbn.shiremei ||
              (props.rowData.shohinshubetsuKbn ===
                shohinshubetsuKbn.madeToOrder &&
                props.rowData.kanryoKbnBefore === kanryoKbn.completed)
            }
          />
        );
      },
    },
    {
      field: "kafusokuRiyu",
      title: "過不足理由",
      width: "12rem",
      editComponent: (props) => {
        const gyoNo = props.rowData.gyoNo;
        return (
          <SCodeSelectCell
            editProps={props}
            value={getSCode(KafusokuRiyu, cellValue(gyoNo, "kafusokuRiyu"))}
            empty={true}
            options={KafusokuRiyu}
            onChange={(newValue) => {
              editCell(gyoNo, "kafusokuRiyu", newValue);
            }}
            disabled={props.rowData.kanryoKbn === kanryoKbn.incomplete}
          />
        );
      },
    },
    { field: "gyoNo", hidden: true, editable: "never" },
    { field: "recordKbn", hidden: true, editable: "never" },
    { field: "nyukayoteikanriNo", hidden: true, editable: "never" },
    { field: "shiredenpyoNo", hidden: true, editable: "never" },
    { field: "shiregyoNo", hidden: true, editable: "never" },
    { field: "juchudenpyoNo", hidden: true, editable: "never" },
    { field: "juchugyoNo", hidden: true, editable: "never" },
    { field: "hachudenpyoNo", hidden: true, editable: "never" },
    { field: "hachugyoNo", hidden: true, editable: "never" },
    { field: "shohinshubetsuKbn", hidden: true, editable: "never" },
    { field: "locationCd", hidden: true, editable: "never" },
    { field: "zaikokanriKbn", hidden: true, editable: "never" },
    { field: "nyukaYmdBefore", hidden: true, editable: "never" },
    { field: "nyukaYmd", hidden: true, editable: "never" },
    { field: "nyukoYmdBefore", hidden: true, editable: "never" },
    { field: "nyukoYmd", hidden: true, editable: "never" },
    { field: "version", hidden: true, editable: "never" },
  ];

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 検索可能に変更
    searched.current = true;
    // 初期ページ設定
    isDefaultPage.current = true;
    // 修正データをリセットする
    tableRef?.current.dataManager.clearBulkEditChangedRows();
    // テーブル再検索
    tableRef.current.onQueryChange();
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched.current) {
        isDefaultPage.current = false;
        searched.current = false;
        editing.current = false;
        setMsg("");
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 編集内容の一時更新
      if (editing.current) {
        editing.current = false;
        setMsg("");
        resolve({
          data: rows.current,
          page: query.page,
          totalCount: query.totalCount,
        });
        return;
      }

      // 修正データをリセットする
      tableRef?.current.dataManager.clearBulkEditChangedRows();
      rows.current = [];
      setMsg("");

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      //  完了区分の値チェック
      let kanryoKbnFindSpec;
      if (fields.kanryoKbn?.value! === "0") {
        kanryoKbnFindSpec = null;
      } else if (fields.kanryoKbn?.value! === "1") {
        kanryoKbnFindSpec = kanryoKbn.incomplete;
      } else if (fields.kanryoKbn?.value! === "2") {
        kanryoKbnFindSpec = kanryoKbn.completed;
      }

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B070020FindRequest = {
        nyukayoteiYmdFrom: fields.nyukayoteiYmdFrom!,
        nyukayoteiYmdTo: fields.nyukayoteiYmdTo!,
        shireCd: fields.shireCd,
        juchudenpyoNo: fields.juchudenpyoNo,
        hachudenpyoNo: fields.hachudenpyoNo,
        shohinCd: fields.shohinCd,
        juchuhinhasoYmdFrom: fields.juchuhinhasoYmdFrom,
        juchuhinhasoYmdTo: fields.juchuhinhasoYmdTo,
        zoneCdFrom: fields.zoneCdFrom,
        zoneCdTo: fields.zoneCdTo,
        kakoshubetsuCd: fields.kakoshubetsuCd,
        shohinshubetsuKbn: fields.shohinshubetsuKbn?.value,
        kanryoKbn: kanryoKbnFindSpec?.toString(),
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        sort: ["nyukayoteiYmdSearch,asc", "nyukayoteikanriNo,asc"],
      };
      // API呼び出し
      B070020Find(param)
        // 正常取得時
        .then((value) => {
          // 検索結果が0件の場合、実行ボタン非活性化
          if (value.data.totalElements === 0) {
            setDisabledRunButton(true);
            // データ非存在メッセージ表示
            setMsg("指定された検索条件に合致するデータは存在しません。");
          } else {
            setDisabledRunButton(false);
          }
          const offset = query.pageSize * query.page;
          rows.current = mapIds(value.data.content, "gyoNo", offset).map(
            (v: Data) => {
              // ロケ選択初期化
              v.locasentaku = locasentaku.off;
              // 入荷選択初期化
              if (
                v.recordKbn === recordKbn.shiremei ||
                v.kanryoKbnBefore === kanryoKbn.completed
              ) {
                v.nyukasentaku = nyukasentaku.off;
              } else {
                v.nyukasentaku = nyukasentaku.on;
              }
              // 入庫選択初期化
              if (
                v.zaikokanriKbn === zaikokanriKbn.off ||
                v.kanryoKbnBefore === kanryoKbn.completed
              ) {
                v.nyukosentaku = nyukosentaku.off;
              } else {
                v.nyukosentaku = nyukosentaku.on;
              }
              return v;
            }
          );
          resolve({
            data: rows.current,
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          setDisabledRunButton(true);
          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // 全選択ボタン
  const handleSelectAll = () => {
    rows.current = rows.current.map((v: Data) => {
      if (v.zaikokanriKbn === zaikokanriKbn.off) return v;
      if (v.kanryoKbnBefore === kanryoKbn.completed) return v;
      v.locasentaku = locasentaku.on;
      return v;
    });
    setMsg("");
    updateRows();
  };
  // 空ロケ選択ボタン
  const handleSelectEmptyLocations = () => {
    rows.current = rows.current.map((v: Data) => {
      if (v.zaikokanriKbn === zaikokanriKbn.off) return v;
      if (v.kanryoKbnBefore === kanryoKbn.completed) return v;
      if (v.locationCdF === "") {
        v.locasentaku = locasentaku.on;
      } else {
        v.locasentaku = locasentaku.off;
      }
      return v;
    });
    setMsg("");
    updateRows();
  };
  // 全解除ボタン
  const handleReleaseAll = () => {
    rows.current = rows.current.map((v: Data) => {
      v.locasentaku = locasentaku.off;
      return v;
    });
    setMsg("");
    updateRows();
  };
  // 一括入力実行ボタン
  const handleBatchEntryExecution = () => {
    const cd = methods.getValues("locationCd") ?? "";
    rows.current = rows.current.map((v: Data) => {
      if (v.locasentaku === locasentaku.off) return v;
      v.locationCdF = cd;
      return v;
    });
    setMsg("");
    updateRows();
  };
  // 完了全選択ボタン
  const handleCompleteAllSelected = () => {
    rows.current = rows.current.map((v: Data) => {
      if (v.recordKbn === recordKbn.shiremei) return v;
      if (
        v.shohinshubetsuKbn === shohinshubetsuKbn.madeToOrder &&
        v.kanryoKbnBefore === kanryoKbn.completed
      )
        return v;
      v.kanryoKbn = kanryoKbn.completed;
      return v;
    });
    setMsg("");
    updateRows();
  };
  // 完了全解除ボタン
  const handleCompleteCancellation = () => {
    rows.current = rows.current.map((v: Data) => {
      v.kanryoKbn = kanryoKbn.incomplete;
      return v;
    });
    setMsg("");
    updateRows();
  };

  // 実行ボタン
  const handleRun = () => {
    setMsg("");
    const nyukaYmd = methods.getValues("nyukaYmd") ?? "";
    const nyukoYmd = methods.getValues("nyukoYmd") ?? "";
    if (nyukaYmd === "") {
      setMsg("入荷日は必須です。");
      return;
    }
    if (nyukoYmd === "") {
      setMsg("入庫日は必須です。");
      return;
    }
    const b070020NyukayoteiRequestList = rows.current.map(
      (v: Data): B070020NyukayoteiRequest => ({
        recordKbn: v.recordKbn,
        shohinCd: v.shohinCd,
        nyukayoteikanriNo: v.nyukayoteikanriNo,
        shiredenpyoNo: v.shiredenpyoNo,
        shiregyoNo: v.shiregyoNo,
        juchudenpyoNo: v.juchudenpyoNo,
        juchugyoNo: v.juchugyoNo,
        hachudenpyoNo: v.hachudenpyoNo,
        hachugyoNo: v.hachugyoNo,
        locationCd: v.locationCdF,
        nyukayoteiYmd: v.nyukayoteiYmd,
        kakuteisu: v.kakuteisu,
        nyukaYmdBefore: v.nyukaYmdBefore,
        nyukaYmd: v.nyukasentaku === nyukasentaku.on ? nyukaYmd : "",
        nyukoYmdBefore: v.nyukoYmdBefore,
        nyukoYmd: v.nyukosentaku === nyukosentaku.on ? nyukoYmd : "",
        kanryoKbnBefore: v.kanryoKbnBefore,
        kanryoKbn: v.kanryoKbn,
        kafusokuRiyu: v.kafusokuRiyu?.value,
        version: v.version,
      })
    );
    const props: B070020UpdateRequest = {
      b070020NyukayoteiRequestList,
    };
    B070020Update(props)
      .then(() => {
        handleClickSearchButton();
        setMsg("処理が完了しました。");
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="入荷・入庫一括確定"
        gridTemplateColumns="6rem 10rem 20rem 1rem 6rem 5rem 1rem 4rem 1rem 5rem 5rem 10rem"
      >
        <SLabel>仕入先コード</SLabel>
        <SNumberField
          name="shireCd"
          label="仕入先コード"
          code="true"
          size={6}
          dialog={<B000170 />}
          handleSubmit={(data: any) => {
            methods.setValue("shireCd", data.shireCd);
            methods.setValue("shireNm", data.shireNmr);
          }}
          onBlur={() => B000170ShireNm(methods, navigate, setMsg)}
          {...register(1)}
        />
        <STextField name="shireNm" label="仕入先名" size={24} disabled />

        <Box />

        <SLabel required>入荷予定日</SLabel>
        <SDateField
          name="nyukayoteiYmdFrom"
          label="入荷予定日(From)"
          gridColumn="span 3"
          required
          {...register(5)}
        />
        <SText>～</SText>
        <SDateField
          name="nyukayoteiYmdTo"
          label="入荷予定日(To)"
          gridColumn="span 2"
          required
          {...register(6)}
        />

        <Box />

        <SLabel>受注No.</SLabel>
        <SNumberField
          name="juchudenpyoNo"
          lable="受注伝票番号"
          code="true"
          size={10}
          {...register(2)}
        />

        <Box gridColumn="span 2" />

        <SLabel>受注品発送日</SLabel>
        <SDateField
          name="juchuhinhasoYmdFrom"
          label="受注品発送日(From)"
          gridColumn="span 3"
          {...register(7)}
        />
        <SText>～</SText>
        <SDateField
          name="juchuhinhasoYmdTo"
          label="受注品発送日(To)"
          gridColumn="span 2"
          {...register(8)}
        />

        <Box />

        <SLabel>発注No.</SLabel>
        <SNumberField
          name="hachudenpyoNo"
          label="発注No."
          code="true"
          size={10}
          dialog={<B000160 eigyosyoKengen={eigyosyoKengen} gamenId={gamenId} />}
          handleSubmit={(data: any) => {
            methods.setValue("hachudenpyoNo", data.hachudenpyoNoF);
          }}
          {...register(3)}
        />

        <Box gridColumn="span 2" />

        <SLabel>ゾーン</SLabel>
        <STextField
          name="zoneCdFrom"
          label="ゾーン(From)"
          code="true"
          size={2}
          dialog={<B000222 />}
          handleSubmit={(data: any) => {
            methods.setValue("zoneCdFrom", data.zoneCd);
          }}
          {...register(9)}
        />
        <SText>～</SText>
        <STextField
          name="zoneCdTo"
          label="ゾーン(To)"
          code="true"
          size={2}
          gridColumn="span 2"
          dialog={<B000222 />}
          handleSubmit={(data: any) => {
            methods.setValue("zoneCdTo", data.zoneCd);
          }}
          {...register(10)}
        />

        <Box gridColumn="span 3" />

        <SLabel>商品コード</SLabel>
        <SNumberField
          name="shohinCd"
          label="商品コード"
          code="true"
          size={10}
          dialog={<B000200 />}
          handleSubmit={(data: any) => {
            methods.setValue("shohinCd", data.shohinCd);
            methods.setValue("shohinNm", data.shohinNmr);
          }}
          onBlur={() => B000200ShohinNm(methods, navigate, setMsg)}
          {...register(4)}
        />
        <STextField name="shohinNm" label="商品名" size={24} disabled />

        <Box />

        <SLabel>加工種別</SLabel>
        <SNumberField
          name="kakoshubetsuCd"
          label="加工種別コード"
          code="true"
          size={3}
          dialog={<B000111 meishoKbn={meishoKbn.kakoshubetsu} />}
          handleSubmit={(data: any) => {
            methods.setValue("kakoshubetsuCd", data.meishoCd);
            methods.setValue("kakoshubetsuNm", data.meishoNm1);
          }}
          onBlur={() => B000111KakoshubetsuNm(methods, navigate, setMsg)}
          {...register(11)}
        />
        <STextField
          name="kakoshubetsuNm"
          label="加工種別名"
          size={40}
          disabled
          gridColumn="span 6"
        />

        <Box gridColumn="span 4" />

        <SLabel>商品種別</SLabel>
        <SCodeSelect
          name="shohinshubetsuKbn"
          label="商品種別"
          options={ShohinshubetsuKbn}
          empty
          gridColumn="span 5"
          {...register(12)}
        />

        <Box gridColumn="span 4" />

        <SLabel>完了</SLabel>
        <SCodeSelect
          name="kanryoKbn"
          label="完了区分"
          options={KanryoKbn}
          gridColumn="span 3"
          {...register(13)}
        />

        <Box gridColumn="span 3" />

        <SNormalButton
          label={labels.buttons.search}
          align="right"
          onClick={handleClickSearchButton}
          {...register(14)}
        />
      </SFrame>
      <SFrame gridTemplateColumns="6rem 10rem 5rem 5rem 5rem 6rem 22rem 5rem 5rem">
        <SLabel>一括入力ロケ</SLabel>
        <STextField
          name="locationCd"
          label="一括入力ロケ"
          gridColumn="span 1"
          location={true}
          size={14}
          {...register(15)}
        />
        <SNormalButton
          label={labels.buttons.SelectAll}
          align="center"
          onClick={handleSelectAll}
          {...register(16)}
        />
        <SNormalButton
          label={labels.buttons.SelectEmptyLocation}
          align="center"
          onClick={handleSelectEmptyLocations}
          {...register(17)}
        />
        <SNormalButton
          label={labels.buttons.ReleaseAll}
          align="center"
          onClick={handleReleaseAll}
          {...register(18)}
        />
        <SNormalButton
          label={labels.buttons.BatchEntryExecution}
          align="center"
          onClick={handleBatchEntryExecution}
          {...register(19)}
        />
        <Box />
        <SNormalButton
          label={labels.buttons.CompleteAllSelected}
          align="center"
          onClick={handleCompleteAllSelected}
          {...register(20)}
        />
        <SNormalButton
          label={labels.buttons.CompleteCancellation}
          align="right"
          onClick={handleCompleteCancellation}
          {...register(21)}
        />
        <SLabel required>入荷日</SLabel>
        <SDateField name="nyukaYmd" label="入荷日" required {...register(22)} />
        <SLabel required>入庫日</SLabel>
        <SDateField
          name="nyukoYmd"
          label="入庫日"
          required
          {...register(23)}
          gridColumn="span 2"
        />
      </SFrame>
      <SFrame>
        <STable
          keyName="gyoNo"
          data={handleSearch}
          columns={columns}
          tableRef={tableRef}
          width={1250}
          height={400}
          edit
          pageSize={pageSize}
        />
      </SFrame>
      <SFrame>
        <SNormalButton
          label={labels.buttons.run}
          align="right"
          disabled={disabledRunButton}
          onClick={handleRun}
          {...register(24)}
        />
      </SFrame>
    </FormProvider>
  );
};
